import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/pages/Dashboard/Dashboard/Overview.vue'
import Stats from 'src/pages/Dashboard/Dashboard/Stats.vue'

// Pages

import TimeLine from 'src/pages/Dashboard/Pages/TimeLinePage.vue'
import Login from 'src/pages/Dashboard/Pages/Login.vue'
import Register from 'src/pages/Dashboard/Pages/Register.vue'
import Lock from 'src/pages/Dashboard/Pages/Lock.vue'

// Components pages
import Buttons from 'src/pages/Dashboard/Components/Buttons.vue'
import GridSystem from 'src/pages/Dashboard/Components/GridSystem.vue'
import Panels from 'src/pages/Dashboard/Components/Panels.vue'
const SweetAlert = () => import('src/pages/Dashboard/Components/SweetAlert.vue')
import Notifications from 'src/pages/Dashboard/Components/Notifications.vue'
import Icons from 'src/pages/Dashboard/Components/Icons.vue'
import Typography from 'src/pages/Dashboard/Components/Typography.vue'

// Forms pages
const RegularForms = () => import('src/pages/Dashboard/Forms/RegularForms.vue')
const ExtendedForms = () => import('src/pages/Dashboard/Forms/ExtendedForms.vue')
const ValidationForms = () => import('src/pages/Dashboard/Forms/ValidationForms.vue')
const Wizard = () => import('src/pages/Dashboard/Forms/Wizard.vue')

// TableList pages
const RegularTables = () => import('src/pages/Dashboard/Tables/RegularTables.vue')
const ExtendedTables = () => import('src/pages/Dashboard/Tables/ExtendedTables.vue')
const PaginatedTables = () => import('src/pages/Dashboard/Tables/PaginatedTables.vue')
// Maps pages
const GoogleMaps = () => import('src/pages/Dashboard/Maps/GoogleMaps.vue')
const FullScreenMap = () => import('src/pages/Dashboard/Maps/FullScreenMap.vue')
const VectorMaps = () => import('src/pages/Dashboard/Maps/VectorMapsPage.vue')

// Calendar
const Calendar = () => import('src/pages/Dashboard/Calendar/CalendarRoute.vue')
// Charts
const Charts = () => import('src/pages/Dashboard/Charts.vue')

// System pages
const UsersManage = () => import('src/pages/Dashboard/Pages/UsersManage.vue')
const BooksManage = () => import('src/pages/Dashboard/Pages/BooksManage.vue')
const AuthorsManage = () => import('src/pages/Dashboard/Pages/AuthorsManage.vue')
const RunsManage = () => import('src/pages/Dashboard/Pages/RunsManage.vue')
const TransactionsManage = () => import('src/pages/Dashboard/Pages/TransactionsManage.vue')
const SalesManage = () => import('src/pages/Dashboard/Pages/SalesManage.vue')
const AmazonSalesManage = () => import('src/pages/Dashboard/Pages/AmazonSalesManage.vue')
const AmazonBooksManage = () => import('src/pages/Dashboard/Pages/AmazonBooksManage.vue')

const UserProfile = () => import('src/pages/Dashboard/Pages/UserProfile.vue')
const User = () => import('src/pages/Dashboard/Pages/UserDetail.vue')
const Book = () => import('src/pages/Dashboard/Pages/BookDetail.vue')
const Author = () => import('src/pages/Dashboard/Pages/AuthorDetail.vue')
const Run = () => import('src/pages/Dashboard/Pages/RunDetail.vue')
const Transaction = () => import('src/pages/Dashboard/Pages/TransactionDetail.vue')
const Sale = () => import('src/pages/Dashboard/Pages/SaleDetail.vue')
const AmazonSale = () => import('src/pages/Dashboard/Pages/AmazonSaleDetail.vue')
const AmazonBook = () => import('src/pages/Dashboard/Pages/AmazonBookDetail.vue')
const StockReport = () => import('src/pages/Dashboard/Pages/StockReport.vue')
const LocationReport = () => import('src/pages/Dashboard/Pages/LocationReport.vue')
const POSReport = () => import('src/pages/Dashboard/Pages/POSReport.vue')
const ProfitReport = () => import('src/pages/Dashboard/Pages/ProfitReport.vue')
const SummaryReport = () => import('src/pages/Dashboard/Pages/SummaryReport.vue')

// authors
import AuthorDashboardLayout from 'src/pages/Dashboard/Layout/AuthorDashboardLayout.vue'
const AuthorRunReport = () => import('src/pages/Dashboard/Pages/AuthorRunReport.vue')

// let componentsMenu = {
//   path: '/components',
//   component: DashboardLayout,
//   redirect: '/components/buttons',
//   children: [
//     {
//       path: 'buttons',
//       name: 'Buttons',
//       component: Buttons
//     },
//     {
//       path: 'grid-system',
//       name: 'Grid System',
//       component: GridSystem
//     },
//     {
//       path: 'panels',
//       name: 'Panels',
//       component: Panels
//     },
//     {
//       path: 'sweet-alert',
//       name: 'Sweet Alert',
//       component: SweetAlert
//     },
//     {
//       path: 'notifications',
//       name: 'Notifications',
//       component: Notifications
//     },
//     {
//       path: 'icons',
//       name: 'Icons',
//       component: Icons
//     },
//     {
//       path: 'typography',
//       name: 'Typography',
//       component: Typography
//     }

//   ]
// }
// let formsMenu = {
//   path: '/forms',
//   component: DashboardLayout,
//   redirect: '/forms/regular',
//   children: [
//     {
//       path: 'regular',
//       name: 'Regular Forms',
//       component: RegularForms
//     },
//     {
//       path: 'extended',
//       name: 'Extended Forms',
//       component: ExtendedForms
//     },
//     {
//       path: 'validation',
//       name: 'Validation Forms',
//       component: ValidationForms
//     },
//     {
//       path: 'wizard',
//       name: 'Wizard',
//       component: Wizard
//     }
//   ]
// }

// let tablesMenu = {
//   path: '/table-list',
//   component: DashboardLayout,
//   redirect: '/table-list/regular',
//   children: [
//     {
//       path: 'regular',
//       name: 'Regular Tables',
//       component: RegularTables
//     },
//     {
//       path: 'extended',
//       name: 'Extended Tables',
//       component: ExtendedTables
//     },
//     {
//       path: 'paginated',
//       name: 'Paginated Tables',
//       component: PaginatedTables
//     }]
// }

// let mapsMenu = {
//   path: '/maps',
//   component: DashboardLayout,
//   redirect: '/maps/google',
//   children: [
//     {
//       path: 'google',
//       name: 'Google Maps',
//       component: GoogleMaps
//     },
//     {
//       path: 'full-screen',
//       name: 'Full Screen Map',
//       component: FullScreenMap
//     },
//     {
//       path: 'vector-map',
//       name: 'Vector Map',
//       component: VectorMaps
//     }
//   ]
// }

// let pagesMenu = {
//   path: '/pages',
//   component: DashboardLayout,
//   redirect: '/pages/user',
//   children: [
//     {
//       path: 'user',
//       name: 'User Page',
//       component: User
//     },
//     {
//       path: 'timeline',
//       name: 'Timeline Page',
//       component: TimeLine
//     }
//   ]
// }

// let loginPage = {
//   path: '/login',
//   name: 'Login',
//   component: Login
// }

// let registerPage = {
//   path: '/register',
//   name: 'Register',
//   component: Register
// }

// let lockPage = {
//   path: '/lock',
//   name: 'Lock',
//   component: Lock
// }

// const routes = [
//   {
//     path: '/',
//     redirect: '/admin/overview'
//   },
//   componentsMenu,
//   formsMenu,
//   tablesMenu,
//   mapsMenu,
//   pagesMenu,
//   loginPage,
//   registerPage,
//   lockPage,
//   {
//     path: '/admin',
//     component: DashboardLayout,
//     redirect: '/admin/overview',
//     meta: {
//       requiresAuth: true
//     },
//     children: [
//       {
//         path: 'overview',
//         name: 'Overview',
//         component: Overview
//       },
//       {
//         path: 'stats',
//         name: 'Stats',
//         component: Stats
//       },
//       {
//         path: 'calendar',
//         name: 'Calendar',
//         component: Calendar
//       },
//       {
//         path: 'charts',
//         name: 'Charts',
//         component: Charts
//       }
//     ]
//   },
//   {path: '*', component: NotFound}
// ]

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  // login
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // dashboard
  {
    path: '/dashboard',
    component: DashboardLayout,
    redirect: '/dashboard/overview',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'overview',
        name: 'Dashboard',
        component: Overview
      }
    ]
  },
  // users
  {
    path: '/users',
    name: 'users',
    component: DashboardLayout,
    redirect: '/users/manage',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'manage',
        name: 'Administración de usuarios',
        component: UsersManage
      },
      {
        path: 'profile',
        name: 'Perfil del usuario',
        component: UserProfile,
        props: true
      },
      {
        path: 'user',
        name: 'Detalle de usuario',
        component: User,
        props: true
      },
    ]
  },
  // books
  {
    path: '/books',
    name: 'books',
    component: DashboardLayout,
    redirect: '/books/manage',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'manage',
        name: 'Administración de títulos físicos',
        component: BooksManage
      },
      {
        path: 'book',
        name: 'Detalle de libro',
        component: Book,
        props: true
      },
      {
        path: 'authors',
        name: 'Administración de autores',
        component: AuthorsManage
      },
      {
        path: 'author',
        name: 'Detalle de autor',
        component: Author,
        props: true
      },
      {
        path: 'runs',
        name: 'Administración de tirajes',
        component: RunsManage
      },
      {
        path: 'run',
        name: 'Detalle de tiraje',
        component: Run,
        props: true
      },
      {
        path: 'amazon',
        name: 'Administración de títulos Amazon',
        component: AmazonBooksManage
      },
      {
        path: 'amazon-book',
        name: 'Detalle de libro Amazon',
        component: AmazonBook,
        props: true
      }
    ]
  },
  // transactions
  {
    path: '/transactions',
    name: 'transactions',
    component: DashboardLayout,
    redirect: '/transactions/manage',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'manage',
        name: 'Administración de consignas',
        component: TransactionsManage
      },
      {
        path: 'transaction',
        name: 'Detalle de transacción',
        component: Transaction,
        props: true
      },
      {
        path: 'sales',
        name: 'Administración de ventas',
        component: SalesManage
      },
      {
        path: 'sale',
        name: 'Detalle de venta',
        component: Sale,
        props: true
      },
      {
        path: 'amazon',
        name: 'Administración de ventas Amazon',
        component: AmazonSalesManage
      },
      {
        path: 'amazon-sale',
        name: 'Detalle de venta Amazon',
        component: AmazonSale,
        props: true
      }
    ]
  },
  // reports
  {
    path: '/reports',
    name: 'reports',
    component: DashboardLayout,
    redirect: '/reports/transactions',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'transactions',
        name: 'Reporte de movimientos',
        component: StockReport
      },
      {
        path: 'location',
        name: 'Reporte ubicación a la fecha',
        component: LocationReport
      },
      {
        path: 'pos',
        name: 'Mejores puntos de venta',
        component: POSReport
      },
      {
        path: 'profit',
        name: 'Reporte de ganancias',
        component: ProfitReport
      },
      {
        path: 'summary',
        name: 'Resumen por ubicación',
        component: SummaryReport,
        props: true
      }
    ]
  },
  // authors
  {
    path: '/author',
    name: 'author',
    component: AuthorDashboardLayout,
    redirect: '/author/runs',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'runs',
        name: 'Reporte de tiraje',
        component: AuthorRunReport
      },
    ]
  },
  // other routes
  {
    path: '*',
    component: NotFound
  }
]

export default routes
